import {Injectable} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {map} from "rxjs/operators";
import {ApplicationModel} from "../models/application.model";
import {DomSanitizer} from "@angular/platform-browser";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ApplicationsService {

  endpoint = environment.API_URL + "rest/vsm";
  logo: any;

  constructor(
    private http: HttpClient,
    private _sanitizer: DomSanitizer,
  ) {}

  getApplications(page: number, pageSize: number, q:string): Observable<ApplicationModel[]> {
    const url = `${this.endpoint}/applications`;
    const params = {
      page:  page.toString(),
      pageSize: pageSize.toString(),
      q: q
    };

    return this.http.get<any>(url, { params }).pipe(
      map(payload => {
        const serviceProvider = payload?.serviceProviderApplications; // Use optional chaining
        if (!serviceProvider) {
          return []; // Return an empty array if serviceProvider is undefined or null
        }

        const entries = Object.entries(serviceProvider); // Get key-value pairs from the object
        let applications: Array<ApplicationModel> = [];

        for (const [key, value] of entries) {
          const applicationModel = ApplicationModel.fromMap(value);
          if (applicationModel) { // Check if applicationModel is not undefined or null
            this.getLogo(applicationModel);
            applications.push(applicationModel);
          }
        }

        return applications;
      })
    );

  }

  private getLogo(applicationModel: ApplicationModel) {
    this.logo = applicationModel.logoFile;
    if (this.logo && this.logo.startsWith('data:image')) {
      this.logo = this._sanitizer.bypassSecurityTrustResourceUrl(applicationModel.logoFile);
    }
    applicationModel.logoFile = this.logo;
  }
}
